const Tabs = {
  props: [
    {
      name: 'value',
      default: '',
      type: 'string',
      desc: 'v-model'
    }
  ],
  slots: [
    {
      name: 'default',
      desc: '只能放 glp-tab-pane 或 el-tab-pane组件'
    }
  ]
}

const TabPane = {
  props: [
    {
      name: 'name',
      default: '',
      type: 'string',
      desc: '名称， 唯一标识'
    },
    {
      name: 'label',
      default: '',
      type: 'string',
      desc: '标题'
    }
  ],
  slots: [
    {
      name: 'default',
      desc: '面板内容'
    }
  ]
}

export default [
  {
    name: 'Tabs API',
    content: Tabs
  },
  {
    name: 'TabPane API',
    content: TabPane
  }
]
